"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_components_text_1 = __importDefault(require("@gerenciatd/next13.components.text"));
const Title = (props) => {
    const dataCy = `Characteristics-Title ${(props === null || props === void 0 ? void 0 : props.index) !== undefined ? `Characteristics-Title-${props.index}` : ""}`;
    return (react_1.default.createElement(react_1.default.Fragment, null, props["Text-1"] && props["Text-1"].text && (react_1.default.createElement("div", { className: `main-characterisctics--title ${props === null || props === void 0 ? void 0 : props.className}`, "data-cy": dataCy },
        react_1.default.createElement(next13_components_text_1.default, Object.assign({}, props["Text-1"], { cyData: "MainCharacteristic Title" }))))));
};
exports.default = Title;
//# sourceMappingURL=index.js.map